/* Do chieu cao that cua chong header dang dinh, ghi vao --nh-sticky-top.
 *
 * Vi sao khong ghi cung mot con so: tren nailhandy.com CO HAI section dinh chong len nhau -
 * thanh thong bao (top 0, cao 33px) roi header (top 33px, cao 101px). Bien --header-height
 * san co cua theme CHI ke header (101px) nen dung mot minh se lam thanh loc bi header che.
 * Chieu cao con doi theo be ngang man hinh va theo do dai chu trong thanh thong bao.
 *
 * Nap boi sections/nh-collection-hero.liquid nen chi chay o trang bo suu tap.
 * Script hong -> CSS roi ve du phong 13.4rem, thanh loc van dinh, chi lech vi tri.
 */
(function () {
  var root = document.documentElement;
  var groups = [];
  var frame = 0;

  // Hai section cung nap file nay (nh-collection-title + nh-theme-chipbar) tren cung mot trang
  // thi chi chay mot lan - lan hai chi them listener trung.
  if (window.__nhStickyTopReady) return;
  window.__nhStickyTopReady = true;

  function collect() {
    groups = Array.prototype.slice.call(
      document.querySelectorAll('.shopify-section-group-header-group')
    );
  }

  function apply() {
    frame = 0;
    if (!groups.length) collect();

    var total = 0;
    for (var i = 0; i < groups.length; i++) {
      var el = groups[i];
      // 07/09/2026: header chuyen sang sticky_header_type = "on-scroll-up" nen o dau trang no
      // CHUA co class shopify-section-header-sticky => computed position la static va phep
      // cong nay bo sot 101px, lam thanh loc + thanh chip ghim chui vao sau header ngay khi
      // khach cuon nguoc len. Header CO the dinh (co <sticky-header> ben trong) thi luon tinh
      // chieu cao cua no; truong hop header dang AN (cuon xuong) do CSS lo:
      // assets/nh-trust-blocks.css ha --nh-sticky-top xuong con thanh thong bao.
      if (window.getComputedStyle(el).position === 'sticky' || el.querySelector('sticky-header')) {
        total += el.offsetHeight;
      }
    }

    if (total > 0) root.style.setProperty('--nh-sticky-top', total + 'px');
  }

  function schedule() {
    if (frame) return;
    frame = window.requestAnimationFrame(apply);
  }

  collect();
  apply();

  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', schedule);

  // Header co the doi chieu cao khi cuon (che do compact) hoac khi thanh thong bao xuong dong.
  if (window.ResizeObserver) {
    var observer = new ResizeObserver(schedule);
    for (var i = 0; i < groups.length; i++) observer.observe(groups[i]);
  }
})();
